<template>
  <div
    class="speech-recogintion-top"
    :class="{
      'height-large': audioObj.isShowRecordPanel,
      'height-small': audioObj.hasClick && !audioObj.isShowRecordPanel,
    }"
  >
    <soundWave
      :showChat="false"
      style="width: 0px; margin: 0 auto"
      ref="soundWave"
      :height="0"
      @started="recordStarted"
      @process="recordProcess"
      @speechEnd="speechEnd"
      @stoped="recordStoped"
      @end="recordEnd"
    >
    </soundWave>
    <audio ref="audio">
      <source src="@/assets/out.mp3" type="audio/mpeg" />
    </audio>
  </div>
</template>

<script>
import soundWave from "./soundWave.vue";
import CryptoJS from "../../../util/crypto-js.mini.js";
import Util from "@/util/util.js";
import axios from "axios";
export default {
  components: { soundWave },
  props: {
    listen: {
      type: Boolean,
      default: true,
    },
    showText: {
      type: Boolean,
      default: true,
    },
    closeKeywords: {
      type: Array,
      default: () => {
        return ["停止", "退出", "退下", "关闭", "再见"];
      },
    },
  },
  data() {
    return {
      recognition: null,
      isInitSpeechRecognitionAssistant: false,
      wakeUpWaitingTimer: null,
      noVoiceTimer: null,
      isUseHandClose: false,
      audioObj: {
        APPID: window._CONFIG.XUNFEI_AUDIO.APPID,
        API_KEY: window._CONFIG.XUNFEI_AUDIO.API_KEY,
        API_SECRET: window._CONFIG.XUNFEI_AUDIO.API_SECRET,
        isRecording: false,
        startTime: 0,
        hasClick: false,
        isShowRecordPanel: false,
        recordStatus: "LISTEN", //  LISTEN  SPEECHEND   STOP   ASKING   ANSWERING
        audio: null,
        audioToTextTempResult: "",
        audioToTextResult: "",
      },
      speakInstance: null,
      websocketInstance: null,
      audioContext: null,
    };
  },
  computed: {
    isWakeUp() {
      return this.$store.state.aiChat.isWakeUp;
    },
  },
  watch: {
    isWakeUp(newVal, oldVal) {
      if (!newVal) {
        this.$refs.audio.play();
        this.stop();
      }
    },
  },
  mounted() {},
  methods: {
    init() {
      this.audioObj.recordStatus = "LISTEN";

      if (this.websocketInstance) {
        this.websocketInstance.close();
      }

      const websocketUrl = this.getWebSocketUrl();
      this.websocketInstance = new WebSocket(websocketUrl);

      this.websocketInstance.onopen = this.onOpen;
      this.websocketInstance.onmessage = this.onMessage;
      this.websocketInstance.onerror = this.onError;
      this.websocketInstance.onclose = this.onClose;
    },

    onOpen() {
      this.sendStartMessage();
    },

    onMessage(event) {
      this.renderResult(event.data);
    },

    onError(event) {
      console.error("WebSocket Error: ", event);
      this.audioObj.isRecording = false;
    },

    onClose(event) {
      this.audioObj.isRecording = false;
      if (event.code === 1006 || event.code === 1000) {
        console.error("WebSocket 超时关闭， code:", event.code);
        this.doClose("WebSocket 超时关闭");
      }
    },

    sendStartMessage() {
      const params = {
        header: {
          status: 0,
          app_id: this.audioObj.APPID,
        },
        parameter: {
          iat: {
            domain: "slm",
            language: "zh_cn",
            accent: "mandarin",
            dwa: "wpgs",
            result: {
              encoding: "utf8",
              compress: "raw",
              format: "json",
            },
          },
        },
        payload: {
          audio: {
            encoding: "raw",
            sample_rate: 16000,
            audio: "",
          },
        },
      };
      this.audioObj.startTime = new Date().getTime();
      this.websocketInstance.send(JSON.stringify(params));
      this.audioObj.isRecording = true;
    },

    getWebSocketUrl() {
      const url = "wss://iat.xf-yun.com/v1";
      const host = "iat.xf-yun.com";
      const apiKey = this.audioObj.API_KEY;
      const apiSecret = this.audioObj.API_SECRET;
      const date = new Date().toUTCString();
      const algorithm = "hmac-sha256";
      const headers = "host date request-line";
      const signatureOrigin = `host: ${host}\ndate: ${date}\nGET /v1 HTTP/1.1`;
      const signatureSha = CryptoJS.HmacSHA256(signatureOrigin, apiSecret);
      const signature = CryptoJS.enc.Base64.stringify(signatureSha);
      const authorizationOrigin = `api_key="${apiKey}", algorithm="${algorithm}", headers="${headers}", signature="${signature}"`;
      const authorization = btoa(authorizationOrigin);
      return `${url}?authorization=${authorization}&date=${date}&host=${host}`;
    },

    bufferToBase64(buffer) {
      let binary = "";
      const bytes = new Uint8Array(buffer);
      for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return window.btoa(binary);
    },

    recordProcess(chunk, powerLevel, duration, sampleRate) {
      if (powerLevel > 10) {
        this.learningNoVoiceClose(null, "录音中， powerLevel > 10");
      }

      if (
        this.websocketInstance &&
        this.websocketInstance.readyState === WebSocket.OPEN &&
        this.audioObj.recordStatus === "LISTEN"
      ) {
        const audioBase64 = this.bufferToBase64(chunk.buffer);
        const params = {
          header: {
            status: 1,
            app_id: this.audioObj.APPID,
          },
          payload: {
            audio: {
              encoding: "raw",
              sample_rate: 16000,
              audio: audioBase64,
            },
          },
        };
        this.websocketInstance.send(JSON.stringify(params));
      }

      if (Date.now() - this.audioObj.startTime > 30000) {
        this.speechEnd();
      }
    },

    speechEnd() {
      console.log("chat-audio-realtime-realtime speechEnd");
      // return
      if (
        this.websocketInstance &&
        this.websocketInstance.readyState === WebSocket.OPEN &&
        this.audioObj.recordStatus === "LISTEN"
      ) {
        const params = {
          header: {
            status: 2,
            app_id: this.audioObj.APPID,
          },
          payload: {
            audio: {
              encoding: "raw",
              sample_rate: 16000,
              audio: "",
            },
          },
        };
        this.websocketInstance.send(JSON.stringify(params));
        this.audioObj.recordStatus = "STOP";
        this.learningNoVoiceClose(1000, "specchEnd 本次说话结束");
      }
    },

    async renderResult(resultData) {
      let self = this;
      const message = JSON.parse(resultData);
      const code = message.header.code;
      const status = message.header.status;

      if (code !== 0) {
        console.error(`请求错误：${code}`);
        this.websocketInstance.close();
        return;
      }

      const payload = message.payload;
      if (payload) {
        let resultText = "";
        const text = JSON.parse(
          CryptoJS.enc.Base64.parse(payload.result.text).toString(
            CryptoJS.enc.Utf8
          )
        );
        const text_ws = text.ws;
        text_ws.forEach((wsItem) => {
          wsItem.cw.forEach((cwItem) => {
            resultText += cwItem.w;
          });
        });

        if (text.pgs) {
          if (text.pgs === "apd") {
            this.audioObj.audioToTextResult =
              this.audioObj.audioToTextTempResult;
          }
          this.audioObj.audioToTextTempResult =
            this.audioObj.audioToTextResult + resultText;
        } else {
          this.audioObj.audioToTextResult = resultText;
        }
      }

      if (status === 2) {
        console.log("科大讯飞识别结果：-----", self.audioObj.audioToTextResult);
        if (
          this.audioObj.audioToTextResult &&
          this.audioObj.audioToTextResult.length > 0
        ) {
          this.stop();
          if (self.isCloseKeyword(self.audioObj.audioToTextResult)) {
            self.$store.commit("setIsWakeUp", false);
            self.doClose("关闭");
          } else {
            await self.wakeUp(self.audioObj.audioToTextResult);
          }
          this.audioObj.audioToTextTempResult = "";
        } else {
          console.log("啥也没听到， 但是已经终止了， 咋办?  重新来吧");
          this.init();
          this.learningNoVoiceClose(2000, "识别不到文字");
        }
      }
    },
    addToChat(params) {
      this.$store.commit("setChatList", {
        msgType: "question",
        infoType: "text",
        msg: params.askInfo,
        ...params,
      });
    },
    /**
     * //  添加临时结果到聊天
     */
    genTempReplyToChat() {
      let loadingObj = { msgType: "AI", loading: true };
      this.$store.commit("setChatList", loadingObj);
    },
    async wakeUp(value) {
      let params = {
        questionID: Math.random().toString(36).slice(2, 12),
        askInfo: value,
      };
      this.addToChat(params);
      this.genTempReplyToChat();
      this.audioObj.recordStatus = "ASKING";
      const answer = await this.askRebot(params);
      this.audioObj.recordStatus = "ANSWERING";
      this.clearLearningNoVoiceClose();
    },
    isCloseKeyword(str) {
      // 关闭词必须 <= 3
      if (str.length > 3) {
        return false;
      }
      for (var i = 0; i < this.closeKeywords.length; i++) {
        let keywords = this.closeKeywords[i];
        if (typeof keywords === "string") {
          if (str.indexOf(keywords) !== -1) {
            return true;
          }
        } else if (Array.isArray(keywords)) {
          let isAllMatch = true;
          for (var j = 0; j < keywords.length; j++) {
            let item = keywords[j];
            if (str.indexOf(item) == -1) {
              isAllMatch = false;
              break;
            }
          }
          if (isAllMatch) {
            return true;
          }
        }
      }
      return false;
    },

    speak(str) {
      return this.$parent.speak(str);
    },

    stopSpeak() {
      return this.$parent.stopSpeak();
    },

    start() {
      let self = this;

      this.audioObj.isShowRecordPanel = true;
      this.$nextTick(() => {
        self.init();
        self.learningNoVoiceClose(null, "刚开始初始化");
        self.$refs.soundWave.recStart();
      });
    },

    play() {
      this.audioObj.recordStatus = "LISTEN";
      this.start();
    },

    suspend() {
      this.stop();
    },

    stop() {
      this.audioObj.recordStatus = "STOP";
      this.websocketInstance.close();
      this.stopSpeak();
      this.$refs.soundWave && this.$refs.soundWave.recStop();
    },

    close() {
      this.isUseHandClose = true;
      this.doClose("手动 close");
    },

    doClose(from) {
      console.log("doClose----", from);
      this.audioObj.isShowRecordPanel = false;
      this.$store.commit("setIsWakeUp", false);
      this.audioObj.recordStatus = "STOP";
      this.websocketInstance.close();
      this.$refs.soundWave && this.$refs.soundWave.recStop();
      this.stopSpeak();
    },
    async askRebot(params) {
      let self = this;
      console.log("askRebot**********************************");
      this.audioObj.isShowRecordPanel = false;
      axios({
        url: window._CONFIG.BACKEND_URL + "/api/assistant/chat",
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          env: window._CONFIG.ENV_CONFIG,
        },
        data: {
          ...params,
        },
      })
        .then((res) => {
          let answerObj = { ...res, msgType: "AI", loading: false };
          self.$store.commit("setChatList", answerObj);
          // AI回答
          const instance = self.speak(answerObj.msg);
          if (answerObj.type === "跳转" && answerObj.url) {
            if (answerObj.url.indexOf("zscq") > -1) {
              self.$router.push("/knowledge");
              self.$store.commit("setKnowledgeJumpUrl", answerObj.url);
              self.$store.commit("setKnowledgeLiteJumpUrl", answerObj.url);
            } else {
              self.$router.push("/");
              self.$store.commit("setJumpUrl", answerObj.url);
            }
          } else {
            if (instance) {
              instance.onStop = (event) => {
                self.audioObj.isShowRecordPanel = true;
                self.play();
                self.learningNoVoiceClose(
                  null,
                  "唤醒之后，播放回答语音，播放结束"
                );
              };
            } else {
              console.error("没有语音示例是不对的，。。。。", instance);
            }
          }
        })
        .catch((e) => {
          console.error("askRebot 报错了", e);
        });
    },

    recordStarted() {
      console.log("Recording started");
    },

    recordStoped(audio) {
      this.audioObj.audio = audio;
    },

    recordEnd() {
      console.log("Recording ended due to no sound detected.");
      this.doClose();
    },

    doUploadAudioFileToMessage(askMessageItem) {
      console.log("doUploadAudioFileToMessage", askMessageItem, this.audioObj);

      if (!this.audioObj.audio || !this.audioObj.audioToTextResult) {
        return;
      }
      /* uni.uploadFile({
				url: window._CONFIG.ajaxBaseUrl + API_SIMPLE_FILE_UPLOAD,
				name: "file",
				file: this.audioObj.audio.blob,
				header: this.header,
				formData: {},
				success: (res) => {
					if (res.statusCode == 200 && JSON.parse(res.data).code == 0) {
						const obj = JSON.parse(res.data).data;
						obj.mediaTimes = this.audioObj.audio.duration;
						obj.fileName = obj.name;
						obj.filePath = obj.path;

						const params2 = {
							id: askMessageItem.id,
							expId: askMessageItem.expId,
							infoType: "text",
							content: askMessageItem.content || this.audioObj.audioToTextResult,
							attachmentList: [obj],
						};

						this.$request.elnAppChatMessageAppendfiles(params2, askMessageItem.expId).then((result) => {
							const messageItem = JSON.parse(JSON.stringify(result.result));
							messageItem.infoType === 'audio';
							this.$emit("update:message", messageItem);
						});
					}
				},
				fail: (err) => {
					console.error(err);
				},
			}); */
    },

    learningNoVoiceClose(time, type) {
      clearTimeout(this.noVoiceTimer);
      this.noVoiceTimer = setTimeout(() => {
        clearTimeout(this.noVoiceTimer);
        this.isUseHandClose = false;
        this.doClose("learningNoVoiceClose");
      }, time || 10000);
    },

    clearLearningNoVoiceClose() {
      clearTimeout(this.noVoiceTimer);
    },
  },
};
</script>

<style lang="less" scoped>
.speech-recogintion-top {
  position: relative;
}
</style>
